// extracted by mini-css-extract-plugin
module.exports = {"clearButton":"_learButton_clearButton__O9CCB","withLabel":"_learButton_withLabel__ocZx1"};